/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'fabric.emoji.add.custom.emoji.label': 'Legg til din egen emoji',
  'fabric.emoji.add.label': 'Legg til emoji',
  'fabric.emoji.cancel.label': 'Avbryt',
  'fabric.emoji.categories.label': 'Velg emoji-kategori',
  'fabric.emoji.categories.search.results': 'Søkeresultater',
  'fabric.emoji.category.activity': 'Aktivitet',
  'fabric.emoji.category.all.uploads': 'Alle filopplastinger',
  'fabric.emoji.category.flags': 'Flagg',
  'fabric.emoji.category.foods': 'Mat og drikke',
  'fabric.emoji.category.frequent': 'Hyppig brukt',
  'fabric.emoji.category.nature': 'Natur',
  'fabric.emoji.category.objects': 'Gjenstander',
  'fabric.emoji.category.people': 'Mennesker',
  'fabric.emoji.category.places': 'Reise og steder',
  'fabric.emoji.category.productivity': 'Produktivitet',
  'fabric.emoji.category.symbols': 'Symboler',
  'fabric.emoji.category.user.uploads': 'Filopplastingene dine',
  'fabric.emoji.choose.file.screenReaderDescription':
    'Velg en fil for emojien. JPG, PNG eller GIF. Maks. størrelse er 1 MB',
  'fabric.emoji.choose.file.title': 'Velg fil',
  'fabric.emoji.delete.description':
    'Alle eksisterende forekomster av denne emoji-en blir erstattet med {emojiShortName}',
  'fabric.emoji.delete.label': 'Fjern',
  'fabric.emoji.delete.screenreader.tooltip': 'Trykk på Tilbake-tasten for å slette emojien {shortName}',
  'fabric.emoji.delete.title': 'Fjern emoji',
  'fabric.emoji.delete.tooltip': 'Slett',
  'fabric.emoji.emojipicker.emoi.roledescription': 'emoji-knapp',
  'fabric.emoji.emojipicker.error': 'Feil!',
  'fabric.emoji.error.delete.failed': 'Kunne ikke fjernes',
  'fabric.emoji.error.image.too.big': 'Det valgte bildet er over 1 MB',
  'fabric.emoji.error.invalid.image': 'Det valgte bildet er ugyldig.',
  'fabric.emoji.error.upload.failed': 'Opplastingen mislyktes',
  'fabric.emoji.error.upload.timeout': 'Opplastingen ble tidsavbrutt',
  'fabric.emoji.image.requirements': 'JPG, PNG eller GIF. Maksimal størrelse 1 MB.',
  'fabric.emoji.name.ariaLabel': 'Angi et navn for den nye emojien',
  'fabric.emoji.picker': 'Emoji-velger',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Søkeresultater} other {Emojier}}',
  'fabric.emoji.pickerlist.tabpanel': 'Emoji-handlinger og -listepanel',
  'fabric.emoji.placeholder': 'f.eks. hei',
  'fabric.emoji.preview': 'Den nye emoji-en {emoji} ser flott ut',
  'fabric.emoji.preview.title': 'Forhåndsvisning',
  'fabric.emoji.retry.label': 'Prøv igjen',
  'fabric.emoji.search.label': 'Emoji-navn',
  'fabric.emoji.search.placeholder': 'Søk',
  'fabric.emoji.search.status': 'Viser alle emojier',
  'fabric.emoji.select.skin.list.ariaLabel': 'Hudfargevelger',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Velg hudfarge, {selectedTone} er valgt',
};
